import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const ACDDiv = styled(BaseStyles.Div)`
    padding: 2rem;
    width:  100vw;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center; 
`

export const ACDComponentsDiv = styled(BaseStyles.Div)`
    box-shadow:
    0 0px 3.8px rgba(0, 0, 0, 0.022),
    0 0px 8.3px rgba(0, 0, 0, 0.031),
    0 0px 14.9px rgba(0, 0, 0, 0.039),
    0 0px 30.5px rgba(0, 0, 0, 0.048),
    0 0px 104px rgba(0, 0, 0, 0.07)
    ;
    margin: auto;
    flex: 1 1 50rem;
    min-width: 30rem;
    max-width: 50rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.8rem;
    background-color: white;
    padding: 0.75%;
`

export const QuickFillerButtonDiv = styled(BaseStyles.Div)`
    margin-bottom: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ACDTextDiv = styled(BaseStyles.Div)`
    padding: 2rem;
`

export const ACDTitle = styled.h2`  
    margin: 0;
    padding: 0;
    margin-bottom: 5rem;
    font-size: 2.2rem;
    font-weight: 550;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center
`

export const ACDPhraseDiv = styled(BaseStyles.Div)`
    margin: 0;
    padding-bottom: 3.5rem;
    font-size: 1.8rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const QuickFillerButton = styled.button`
    margin: 0;
    padding: 0;
    color: black;
    background-color: transparent;
    outline-style: none;
    cursor: pointer;
    font-size: 3rem;
    border: none;
    font-weight: bold;
    font-family: "Helvetica Neue";
    &:hover {
        color: #4267B2;
    }
`

export const ACDExitPhraseDiv = styled(BaseStyles.Div)`
    margin: 0;
    padding: 0;
    font-size: 1.5rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ACDExitPhrase = styled.p`
    display: inline;
`

export const HereLink = styled.a`
    margin: 0;
    padding: 0;
    color: black;
    font-size: 1.5rem;
`